// src/redux/action/admin/services/action.js
import {
  SET_ALL_DATA_OF_ADMIN_SERVICES,
  SET_SERVICES_ADMIN_SERVICES,
  SET_FILTERED_ADMIN_SERVICES,
  SET_PAGES_DATA_ADMIN_SERVICES,
  RESET_ALL_ADMIN_SERVICES_DATA,
} from "./type";

export const setAllDataOfAdminServices = (payload) => ({
  type: SET_ALL_DATA_OF_ADMIN_SERVICES,
  payload,
});

export const setServicesAdminServices = (payload) => ({
  type: SET_SERVICES_ADMIN_SERVICES,
  payload,
});

export const setFilteredAdminServices = (payload) => ({
  type: SET_FILTERED_ADMIN_SERVICES,
  payload,
});

export const setPagesDataAdminServices = (payload) => ({
  type: SET_PAGES_DATA_ADMIN_SERVICES,
  payload,
});

export const resetAllAdminServicesData = () => ({
  type: RESET_ALL_ADMIN_SERVICES_DATA,
});
